var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 50 48.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(-125 -125.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M130.222,173.679a2.068,2.068,0,0,0,2.988-.246l3.824-4.9a.6.6,0,0,0,.69-.147l.823-.922a.6.6,0,0,0,.12-.589,8.159,8.159,0,1,0-2.633-2.351.6.6,0,0,0-.572.186l-.823.922a.6.6,0,0,0-.069.7l-4.441,4.354A2.068,2.068,0,0,0,130.222,173.679Zm7.868-18a6.119,6.119,0,1,1,.49,8.639A6.125,6.125,0,0,1,138.09,155.678Z",
    fill: "#d99d00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M165.133,135.614H162.11l-3.5-6.763-13.049,6.763h-5.888l18.539-9.628a1.594,1.594,0,0,1,1.353-.079,1.882,1.882,0,0,1,1.034.875Z",
    fill: "#d99d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M133.147,138.956c0,.159-.079.4-.079.557v2.546l-5.093,2.626,5.093,9.786v5.809l-.159-.239-7.719-14.879a1.785,1.785,0,0,1-.079-1.432,1.876,1.876,0,0,1,.955-1.114Z",
    fill: "#d99d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M173.25,137.682h-36.2a1.8,1.8,0,0,0-1.831,1.831V153.8c.106-.135.217-.267.332-.394a9.482,9.482,0,0,1,2.294-1.878V140.389h34.453v20.129h-9.467a1.567,1.567,0,0,0-1.513,1.513V171.5H137.841v-1.629c-.049.014-.1.027-.146.038l-2.4,3.073a1.767,1.767,0,0,0,1.668,1.224h25.779a1.658,1.658,0,0,0,.876-.319l11.06-11.058a1.2,1.2,0,0,0,.318-.876V139.432A1.766,1.766,0,0,0,173.25,137.682Zm-9.31,31.988v-6.446h6.445Z",
    fill: "#d99d00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M158.609,165.133a1.258,1.258,0,0,1-1.273,1.274h-7.867c.1-.1.2-.2.292-.31a9.493,9.493,0,0,0,1.491-2.236h6.084A1.257,1.257,0,0,1,158.609,165.133Z",
    fill: "#d99d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M158.609,158.051a1.258,1.258,0,0,1-1.273,1.274h-5.168l-.006-.112a9.466,9.466,0,0,0-.456-2.434h5.63A1.257,1.257,0,0,1,158.609,158.051Z",
    fill: "#d99d00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M169.589,145.082v5.411a1.223,1.223,0,0,1-1.193,1.193h-20.67a9.537,9.537,0,0,0-7.1-1.237v-5.367a1.224,1.224,0,0,1,1.193-1.193H168.4A1.222,1.222,0,0,1,169.589,145.082Z",
    fill: "#d99d00"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.ee6e5bef.svg";
export { ForwardRef as ReactComponent };